"use client";
import { BlocksView } from "./BlocksView";
import { useAttr, useBlock } from "./context";
import type { BlockData } from "../types";

/** Nested ordinary builder blocks, for example a catalog sidebar. */
export function BlockArea({ name }: { name: string }) {
  const context = useBlock();
  const [value, setValue] = useAttr<BlockData[]>(name);
  if ((context.areaDepth ?? 0) >= 4) return null;
  const blocks = Array.isArray(value) ? value.filter((block) => block && typeof block.id === "string" && typeof block.type === "string" && !block.hiddenIn?.includes(context.locale)) : [];
  const data = context.data as { __cmsAreas?: Record<string, Record<string, unknown>> } | undefined;
  return <BlocksView themeId={context.themeId} blocks={blocks} blockData={data?.__cmsAreas?.[name] ?? {}}
    locale={context.locale} locales={context.locales} localeDomains={context.localeDomains}
    enabledModules={context.enabledModules} editing={context.editing} preview={context.preview} areaDepth={(context.areaDepth ?? 0) + 1}
    blockIndexOffset={1} onChange={(next) => {
      // Preserve blocks hidden in this locale when editing the visible area.
      const hidden = Array.isArray(value) ? value.filter((block) => block.hiddenIn?.includes(context.locale)) : [];
      setValue([...next, ...hidden]);
    }} />;
}
